import React from 'react';
import './MySignals.scss';
import { useAuth } from '../../../commons/Auth';
import MySignalsPresentational from './MySignalsPresentational';

const MySignalsSpecialJobs = ({
  profile,
  query,
  total,
  signals,
  signalTypes,
  onFilter,
}) => {
  const [{ newToken, newIsAdmin } = {}] = useAuth();

  return (
    <MySignalsPresentational
      data={signals}
      profile={profile}
      newIsAdmin={newIsAdmin}
      query={query}
      total={total}
      onFilter={onFilter}
    />
  );
};

export default MySignalsSpecialJobs;
